jQuery(document).ready(function ($) {
    var ajaxurl = 'https://api.stickerplease.com/index.php';

    // ---------------------------------------------------------------------------
    // Preview generation for non-browser-renderable uploads.
    // The server (Imagick) generates previews for PSD/TIFF and returns preview_url.
    // PDF/AI cannot be rasterised server-side here (Ghostscript/exec are disabled in
    // php-fpm), so we render page 1 in the browser with PDF.js and POST the result to
    // gw_savePreview. Anything we can't preview falls back to a clean file-type icon.
    // ---------------------------------------------------------------------------
    // SELF-HOSTED, NOT cdnjs (item 117). These two were
    // https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/… — a third-party
    // host in the order path of every sticker sale, which is the same defect as
    // DUMMYIMAGE-IN-ORDER-PATH and had simply never been noticed. The theme now
    // carries the pinned 3.11.174 legacy build in assets/, one copy, one origin,
    // shared with sign-uploader.js 8.5.
    //
    // DERIVED FROM THIS SCRIPT'S OWN src, not from Liquid. The sign block gets
    // its URLs from data attributes, but this file is loaded by
    // gw-product-image-hero-section.liquid on pages that have no sign block at
    // all, and that section is not in this step's scope. Its own <script> tag
    // already carries the versioned assets path, so the siblings are one
    // replace away and the theme id (t/3 live, t/4 duplicate) comes out right
    // on both without anything being hardcoded.
    var SP_ASSETS_BASE = (function () {
      var me = document.querySelector('script[src*="uploader_complement.js"]');
      if (!me || !me.src) return '';
      return me.src.replace(/uploader_complement\.js.*$/, '');
    })();
    var SP_PDFJS_URL    = SP_ASSETS_BASE ? SP_ASSETS_BASE + 'pdf.min.js' : '';
    var SP_PDFJS_WORKER = SP_ASSETS_BASE ? SP_ASSETS_BASE + 'pdf.worker.min.js' : '';
    var spPdfJsPromise = null;

    function spLoadPdfJs() {
      if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
      if (spPdfJsPromise) return spPdfJsPromise;
      if (!SP_PDFJS_URL) return Promise.reject(new Error('PDF.js asset path unresolved'));
      spPdfJsPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = SP_PDFJS_URL;
        s.onload = function () {
          try { if (window.pdfjsLib) window.pdfjsLib.GlobalWorkerOptions.workerSrc = SP_PDFJS_WORKER; } catch (e) {}
          resolve(window.pdfjsLib);
        };
        s.onerror = function () { reject(new Error('Could not load PDF.js')); };
        document.head.appendChild(s);
      });
      return spPdfJsPromise;
    }

    function spReadArrayBuffer(file) {
      if (file.arrayBuffer) return file.arrayBuffer();
      return new Promise(function (resolve, reject) {
        var r = new FileReader();
        r.onload = function () { resolve(r.result); };
        r.onerror = function () { reject(new Error('Could not read file')); };
        r.readAsArrayBuffer(file);
      });
    }

    // Render page 1 of a PDF/PDF-compatible-AI File to a white-matted PNG Blob.
    function spRenderPdfToBlob(file) {
      return spLoadPdfJs()
        .then(function (pdfjsLib) {
          if (!pdfjsLib) throw new Error('PDF.js unavailable');
          return spReadArrayBuffer(file);
        })
        .then(function (buf) { return window.pdfjsLib.getDocument({ data: buf }).promise; })
        .then(function (pdf) { return pdf.getPage(1); })
        .then(function (page) {
          var base = page.getViewport({ scale: 1 });
          var target = 800;
          var scale = Math.min(target / base.width, target / base.height, 3);
          if (!isFinite(scale) || scale <= 0) scale = 1;
          var vp = page.getViewport({ scale: scale });
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.floor(vp.width));
          canvas.height = Math.max(1, Math.floor(vp.height));
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          return page.render({ canvasContext: ctx, viewport: vp }).promise.then(function () {
            return new Promise(function (resolve) { canvas.toBlob(function (b) { resolve(b); }, 'image/png'); });
          });
        });
    }

    // POST a rendered preview Blob to the server; resolves to the stored preview URL.
    function spSavePreview(name, blob) {
      var fd = new FormData();
      fd.append('action', 'gw_savePreview');
      fd.append('name', name);
      fd.append('preview', blob, 'preview.png');
      return fetch(ajaxurl, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.status === 'success' && d.preview_url) return d.preview_url;
          throw new Error((d && d.message) || 'Could not save preview');
        });
    }

    function spBasenameFromUrl(u) {
      if (!u) return '';
      u = String(u).split('?')[0].split('#')[0];
      var parts = u.split('/');
      try { return decodeURIComponent(parts[parts.length - 1] || ''); }
      catch (e) { return parts[parts.length - 1] || ''; }
    }

    function spExtFromUrl(u) {
      var base = spBasenameFromUrl(u);
      var m = base.match(/\.([^.]+)$/);
      return m ? m[1].toLowerCase() : '';
    }

    // Debug AJAX requests - only critical errors
    $(document).ajaxError(function(event, jqxhr, settings, error) {
        console.error('AJAX Error:', {
            url: settings.url,
            status: jqxhr.status,
            error: error
        });
    });
  
    $.fn.checkFileStatus = function (file_id) {
      return new Promise((resolve, reject) => {
        function checkStatus() {
          $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
              action: 'gw_checkFileStatus',
              file_id: file_id,
            },
            dataType: 'json',
            success: (data) => {
              // Verify if data is a string (possibly unparsed JSON)
              if (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch (e) {
                  console.error('Error parsing JSON:', e);
                }
              }
              
              if (data.status === 'continue_searching_status') {
                setTimeout(checkStatus, 1000);
              } else if (data.status === 'success') {
                resolve(data.file_url);
              } else if (data.status === 'error') {
                reject(data.message || 'Unknown error from server');
              } else {
                reject('Unknown status: ' + data.status);
              }
            },
            error: (xhr, status, error) => {
              // Try to parse the responseText as JSON
              let errorMessage = error;
              try {
                if (xhr.responseText) {
                  const errorResponse = JSON.parse(xhr.responseText);
                  if (errorResponse.message) {
                    errorMessage = errorResponse.message;
                  }
                }
              } catch (e) {}
              
              reject(errorMessage);
            }
          });
        }
    
        // Start the verification process
        checkStatus();
      });
    };
  
    //UPLOADER
    $.fn.uploadImageField = function () {
      $('[data-image-uploader]').not('.uploader_loaded').each(function (idx, field) {
        $(field).addClass('uploader_loaded');
    
        const input_name = $(field).attr('name');
        const save_input_name = input_name.replace('_uploader', '');
        const $form = $(field).closest('form');
    
        const item_html = `
          <div class="file_item">
            \${image}
            <span class="remove_item" data-action="fileuploader-remove"><i class="remove_item_icon"></i></span>
            <div class="progressbar3" style="display: none"></div>
          </div>
        `;
    
        $(field).fileuploader({
          theme: 'upload_box',
          addMore: true,
          enableApi: true,
          dragDrop: {
            container: '.file_uploader_box',
          },
          onSelect: function(item) {
            // Only run browser image-decode validation on web-renderable raster types.
            // Design files like PSD/TIFF/AI/EPS/PDF/SVG can report image/* MIME on some
            // browsers but won't decode in an <img>, so they pass through to the server.
            if (item.file && /^image\/(png|jpe?g|gif|webp|bmp)$/i.test(item.file.type)) {
              // Use Promise to handle async validation
              return new Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onload = function(e) {
                  var image = new Image();
                  image.onload = function() {
                    // We no longer need to validate dimensions as the server will handle resizing
                    // Just resolve the promise to allow the file to be added
                    resolve();
                  };
                  image.onerror = function() {
                    console.error('Error loading image for validation.');
                    // Reject if image cannot be loaded
                    reject(new Error('Could not load the image for validation.')); 
                  };
                  image.src = e.target.result;
                };
                reader.onerror = function() {
                  console.error('Error reading file for validation.');
                  // Reject if file cannot be read
                  reject(new Error('Could not read the file for validation.')); 
                };
                reader.readAsDataURL(item.file);
              }).then(function() {
                // Validation passed, allow the file by returning true
                return true;
              }).catch(function(error) {
                // Validation failed, prevent the file by returning false
                // The alert is already shown inside the promise
                return false;
              });
            } else {
              // Not an image file, allow it by returning true
              return true;
            }
          },
          changeInput:
            '<div class="file_uploader_box position-relative w-100"><div class="fileuploader-droparea" data-action="fileuploader-input"></div></div>',
          thumbnails: {
            box: '<div class="thumbnails_area">' + '<div class="file_items"></div>' + '</div>',
            item: item_html,
            item2: null,
            itemPrepend: true,
            startImageRenderer: true,
            canvasImage: false,
            _selectors: {
              list: '.file_items',
            },
          },
          onListInput: function (list, fileList, listInputEl, listEl, parentEl, newInputEl, inputEl) {
            if (fileList.length > 0) $(parentEl).addClass('with_items');
            return list;
          },
          afterRender: function (listEl, parentEl, newInputEl, inputEl) {
            var api = $.fileuploader.getInstance(inputEl);
    
            parentEl.on('click', '[data-action]', function () {
              var $this = $(this),
                action = $this.attr('data-action'),
                item = api.getFiles().length ? api.getFiles()[api.getFiles().length - 1] : null;
    
              switch (action) {
                case 'fileuploader-input':
                  api.open();
                  break;
                case 'fileuploader-edit':
                  if (item && item.popup) {
                    if (!$this.is('.fileuploader-action-popup')) item.popup.open();
                    item.editor.cropper();
                  }
                  break;
                case 'fileuploader-retry':
                  if (item && item.upload.retry) {
                    item.upload.retry();
                  }
                  break;
                case 'fileuploader-remove':
                  if (item) {
                    item.remove();
                    $('#add_to_cart_button').prop('disabled', true);
                  }
                  break;
              }
            });
          },
          onRemove: function (item, listEl, parentEl, newInputEl, inputEl) {
            console.log('Removing file:', item);
            
            // Clear the input field value
            $(`#${save_input_name}`).val('');
            
            // Only try to delete from server if we have an attachment ID
            if (item.data && item.data.attachment_id) {
              $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                  action: 'gw_deleteFile',
                  file: item.data.attachment_id,
                },
                success: (response) => {
                  console.log('File deleted from server');
                },
                error: (xhr, status, error) => {
                  console.error('Error deleting file from server');
                }
              });
            }
          },
          onEmpty: function (listEl, parentEl, newInputEl, inputEl) {
            $(parentEl).removeClass('with_items');
          },
          upload: {
            url: ajaxurl,
            type: 'POST',
            enctype: 'multipart/form-data',
            data: {
              action: 'gw_uploadFile',
              input_name: input_name,
            },
            start: true,
            synchron: true,
            beforeSend: () => {
              $('.upload_input_wrapper').addClass('loading');
            },
              onSuccess: function (result, item) {
              console.log('Raw upload response:', result);
              
              // Verify if result is a string (possibly unparsed JSON)
              if (typeof result === 'string') {
                try {
                  result = JSON.parse(result);
                  console.log('Parsed JSON result:', result);
                } catch (e) {
                  console.error('Error parsing JSON result:', e);
                  console.error('Raw result that failed to parse:', result);
                  $('.upload_input_wrapper').removeClass('loading');
                  item.html.find('.progress-bar').hide();
                  item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: Invalid server response</div>');
                  return false;
                }
              }
              
              // Clear any previous error messages
              item.html.find('.error-message').remove();

              // Helper to update the thumbnail <img> src with a real URL
              function updateThumbnailSrc(url) {
                if (!url) return;
                var $thumbImg = item.html.find('.fileuploader-item-image img');
                if (!$thumbImg.length) {
                  $thumbImg = item.html.find('img');
                }
                if ($thumbImg.length) {
                  $thumbImg.attr('src', url);
                }
              }

              // Tracks whether we've already shown a real artwork preview, so the
              // later Shopify-media thumbnail (a generic placeholder for non-images)
              // doesn't overwrite it.
              var spHasRealPreview = false;
              function spSetPreview(url) {
                if (!url) return;
                spHasRealPreview = true;
                ($form.length ? $form : $(document)).find(`#${save_input_name}`).attr('data-preview-url', url);
                updateThumbnailSrc(url);
              }

              // Decide how to obtain a web-viewable preview for this upload:
              //  - server already made one (PSD/TIFF) -> result.preview_url
              //  - PDF/AI -> render page 1 in the browser, store it server-side
              //  - images (jpg/png/gif/webp/svg) -> the file itself is the preview
              function handlePreview(fileUrl, serverPreviewUrl) {
                if (serverPreviewUrl) { spSetPreview(serverPreviewUrl); return; }
                var ext = spExtFromUrl(fileUrl);
                if ((ext === 'pdf' || ext === 'ai') && item && item.file) {
                  spRenderPdfToBlob(item.file)
                    .then(function (blob) {
                      if (!blob) throw new Error('No preview produced');
                      return spSavePreview(spBasenameFromUrl(fileUrl), blob);
                    })
                    .then(function (url) { spSetPreview(url); })
                    .catch(function (err) { console.warn('Browser preview generation failed:', err); });
                }
              }

              if (result.status === 'pending') {
                console.log('File upload pending, checking status for file_id:', result.file_id);
                
                // Guardar de inmediato la URL REAL del archivo subido para usarla en el carrito / archivo original
                if (result.file_url) {
                  ($form.length ? $form : $(document)).find(`#${save_input_name}`).val(result.file_url);
                  // Update thumbnail src so popup can use the real URL
                  updateThumbnailSrc(result.file_url);
                  // Generate / apply a web-viewable preview (PSD/TIFF from server, PDF/AI in-browser)
                  handlePreview(result.file_url, result.preview_url);
                }

                // Mostrar mensaje de procesamiento mientras Shopify termina de procesar el archivo (si aplica)
                item.html.find('.progress-bar').html('<span>Processing image...</span>');
                
                // Seguir comprobando el estado en Shopify, pero sin sobreescribir la URL real almacenada
                $.fn.checkFileStatus(result.file_id)
                  .then(file_url => {
                    console.log('File ready in Shopify, URL:', file_url);

                    // Guardar la URL de Shopify (galería de medios) si existe un campo dedicado
                    const $shopifyInput = ($form.length ? $form : $(document)).find('#shopify_image');
                    if ($shopifyInput.length && file_url) {
                      $shopifyInput.val(file_url);
                    }

                    // Optionally update thumbnail to use the Shopify media URL —
                    // but never clobber a real artwork preview with the placeholder.
                    if (!spHasRealPreview) updateThumbnailSrc(file_url);

                    $('.upload_input_wrapper').removeClass('loading');
                    $('#add_to_cart_button').prop('disabled', false);
                    
                    // Ocultar la barra de progreso tras completar
                    setTimeout(() => {
                      item.html.find('.progress-bar').fadeOut(400);
                    }, 400);
                  })
                  .catch(error => {
                    console.error('Error checking file status:', error);
                    $('.upload_input_wrapper').removeClass('loading');
                    
                    // Mostrar mensaje de error en la interfaz
                    item.html.find('.progress-bar').hide();
                    item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: ' + error + '</div>');
                    
                    // Habilitar botón de reintento
                    if (item.html.find('.fileuploader-action-retry').length === 0) {
                      item.html.find('.column-actions').prepend(
                        '<button type="button" class="fileuploader-action fileuploader-action-retry" title="Retry"><i class="fileuploader-icon-retry"></i></button>'
                      );
                    }
                  });
              } else if (result.status === 'success') {
                console.log('Upload Success', result.file_url);
                // If the file was uploaded successfully without verification
                $(`#${save_input_name}`).val(result.file_url || '');
                // Update thumbnail src to use the uploaded file URL
                updateThumbnailSrc(result.file_url || '');
                // Generate / apply a web-viewable preview (PSD/TIFF from server, PDF/AI in-browser)
                handlePreview(result.file_url || '', result.preview_url);

                $('.upload_input_wrapper').removeClass('loading');
                $('#add_to_cart_button').prop('disabled', false);
                
                // Hide progress bar after completion
                setTimeout(() => {
                  item.html.find('.progress-bar').fadeOut(400);
                }, 400);
              } else if (result.status === 'error') {
                console.error('Upload error:', result);
                $('.upload_input_wrapper').removeClass('loading');
                
                // Show error message in the interface
                item.html.find('.progress-bar').hide();
                let errorMessage = 'Unknown error uploading file';
                
                // Handle specific errors
                if (result.warnings && result.warnings.length > 0) {
                  const warning = result.warnings[0];
                  if (warning.includes('upload_max_filesize')) {
                    errorMessage = 'The file is too large. Please reduce the image size to less than 200MB.';
                  } else {
                    errorMessage = warning;
                  }
                } else if (result.message) {
                  errorMessage = result.message;
                }
                
                item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: ' + errorMessage + '</div>');
                
                // Enable retry button
                if (item.html.find('.fileuploader-action-retry').length === 0) {
                  item.html.find('.column-actions').prepend(
                    '<button type="button" class="fileuploader-action fileuploader-action-retry" title="Retry"><i class="fileuploader-icon-retry"></i></button>'
                  );
                }
                
                return false;
              } else {
                console.error('Unknown status:', result);
                $('.upload_input_wrapper').removeClass('loading');
                
                // Show error message in the interface
                item.html.find('.progress-bar').hide();
                item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: Unknown server status</div>');
                
                return false;
              }
            },
            onError: function (item) {
              var progressBar = item.html.find('.progress-bar');
    
              if (progressBar.length) {
                progressBar.find('span').html(0 + '%');
                progressBar.find('.fileuploader-progressbar .bar').width(0 + '%');
                item.html.find('.progress-bar').fadeOut(400);
              }
    
              item.upload.status != 'cancelled' && item.html.find('.fileuploader-action-retry').length == 0
                ? item.html
                    .find('.column-actions')
                    .prepend(
                      '<button type="button" class="fileuploader-action fileuploader-action-retry" title="Retry"><i class="fileuploader-icon-retry"></i></button>'
                    )
                : null;
            },
            onProgress: function (data, item) {
              var progressBar = item.html.find('.progress-bar');
    
              if (progressBar.length > 0) {
                progressBar.show();
                progressBar.find('span').html(data.percentage + '%');
                progressBar.find('.fileuploader-progressbar .bar').width(data.percentage + '%');
              }
            },
            onComplete: null,
          },
        });
      });
    };
    
    $.fn.uploadImageField();
  });
  